import EfShopingCart from '@elem/ui/ef-shoping-cart';

export default function GloCart({ systemTimestamp }: { systemTimestamp: number }) {
    return (
        <>
            <EfShopingCart systemTimestamp={systemTimestamp} />
            {/* <EcoCart /> */}
        </>
    );
}
